"use strict";

$(document).ready(function () {
    function initialize() {
        $('#backInStock-btn').on('click',function(e) {
            $('#backinstock-msg').html('').removeClass('alert-danger').removeClass('alert-success');
            $("#backInStockModal").modal('show');
        });

        $("#backinstock-submit").off(backInStockSubmit).click(backInStockSubmit);
    }

    function backInStockSubmit(event) {
        event.preventDefault();

        var email = $('#backinstock-email').val();
        if(!validateEmail(email)){
            $('#backinstock-msg').addClass('alert-danger').html($('#backinstock-email').data("parse-error"));
            return ;
        }

        var backinstockTermsAndConditions = $('#backinstockTermsAndConditions').prop('checked');

        if (!backinstockTermsAndConditions) {
            $('#backinstock-msg').addClass('alert-danger').html($('#backinstockTermsAndConditions').data("missing-error"));
            return ;
        }

        var firstName = $('#backinstock-firstName').val();
        var lastName = $('#backinstock-lastName').val();
        var pid = $('#backinstock-pid').val();

        var data = {
            firstName: firstName,
            lastName: lastName,
            email: email,
            pid: pid
        };

        $.ajax({
            url: $("#backInStockForm").data("csrfToken"),
            method: "POST",
            success: function(tokenResponse) {
                data[tokenResponse.csrf.tokenName] = tokenResponse.csrf.token;

                let formAction = $("#backInStockForm").attr("action");

                var options = {
                    data : data,
                    url : formAction,
                    type : 'post'
                };

                $.ajax(options).done(function (response) {
                    if (response.success) {
                        $('#backinstock-msg').removeClass('alert-danger').addClass('alert-success').html(response.message);
                    }else {
                        $('#backinstock-msg').removeClass('alert-success').addClass('alert-danger').html(response.message);
                    }
                });
            },
            error: function(tokenError) {
              // Handle error getting the token
              $('#backinstock-msg').removeClass('alert-success').addClass('alert-danger').html(tokenError);
            }
        });
    }

    function validateEmail(email){
        var regex = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/;
        return regex.test(email);
    }

    initialize();
});
